"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFood3 = function IconFood3(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m30.644 4.302.703.815a53.1 53.1 0 0 1 12.71 30.167l.05.643.08 1.073H19v4.5a1.5 1.5 0 0 1-2.993.145L16 41.5V35h1v6.5a.5.5 0 0 0 .992.09L18 41.5V35h24.021l-.017-.187A51.1 51.1 0 0 0 30.648 7.39l-.121-.144L4.756 33.018c-.3.299-.41.734-.299 1.134l.046.132c.164.395.53.665.95.71L5.58 35H13v4.5a.5.5 0 0 0 .992.09L14 39.5V35h1v4.5a1.5 1.5 0 0 1-2.993.145L12 39.5V37H5.582a3.16 3.16 0 0 1-2.384-5.242l.145-.155zM18 27a3 3 0 1 1 6 0 3 3 0 0 1-6 0m5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m3-9a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-13.123-.623a2 2 0 0 0 .049-2.778l-.732.682.078.095a1 1 0 0 1-1.491 1.318l-.682.732.128.11a2 2 0 0 0 2.65-.16m15.222-7.803.682.732a1 1 0 0 0 1.326 1.496l.087-.083.732.682a2 2 0 0 1-2.945-2.707zm8.436 7.842a46.1 46.1 0 0 0-8.228-19.357l-1.614 1.182.397.55a44.1 44.1 0 0 1 7.582 18.615l1.976-.312z",
    clipRule: "evenodd"
  })));
};

export { IconFood3, IconFood3 as default };
